import { defineStore } from 'pinia';
import { TABLE_SETTINGS } from 'SharedDir/constants/table-settings';
import { PaginationParams } from 'SharedDir/declarations/pagination';
import { Filters } from 'PortalDir/modules/News/composables/usePublicNewsFilters';
import { NewsBare } from 'SharedDir/declarations/news';

export interface NewsStateInterface {
  newsList: Array<NewsBare>;
  news: NewsBare | object;
  pagination: PaginationParams<any>;
  filters: Filters;
}
export const useNewsStore = defineStore('news', {
  state: () =>
    <NewsStateInterface>{
      newsList: [],
      news: {},
      pagination: {
        page: 1,
        rowsPerPage: TABLE_SETTINGS.ROWS_PER_PAGE,
        rowsNumber: 1,
        sortBy: 'id',
        descending: false,
      },
      filters: {
        groupId: null,
        name: null,
        kindId: null,
        typeId: null,
        formId: null,
        departmentId: null,
        profileTypeId: null,
        municipalAreas: [],
        segments: [],
        applicationStartsFrom: null,
        applicationStartsTo: null,
      },
    },

  getters: {},

  actions: {
    setNewsList(value: Array<any>) {
      this.newsList = value;
    },
    setNewsPagination(value: object) {
      this.pagination = value;
    },
    setNewsFilter(value) {
      this.filters = value;
    },
    setNews(value) {
      this.news = value;
    },
  },
});
